<mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    [formControl]="fc"
    [attr.data-testid]="testId || null"
    [placeholder]="placeholder"
    inputmode="numeric"
    autocomplete="off"
    (input)="onInput($event)"
    (keydown)="onKeydown($event)"
    (paste)="onPaste($event)"
    (blur)="onBlur()"
  />
  <mat-datepicker-toggle matSuffix [for]="picker">
    <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
  </mat-datepicker-toggle>
  <mat-error>{{ errorMessageKey | translate }}</mat-error>
</mat-form-field>
<!-- Material datepicker must be linked to an input with [matDatepicker]; kept off-screen. -->
<input
  class="sr-only"
  matInput
  [matDatepicker]="picker"
  [formControl]="pickerFc"
  [max]="pickerMax"
  [min]="pickerMin"
  tabindex="-1"
  aria-hidden="true"
  (dateChange)="onPickerDateChange($event)"
/>
<mat-datepicker #picker />
